import {NgModule} from '@angular/core'
import {CommonModule} from '@angular/common'
import {FormsModule, ReactiveFormsModule} from '@angular/forms'
import {BrowserAnimationsModule} from '@angular/platform-browser/animations'

import {PipeModule} from '../pipe/pipe.module'
import {UISharedModule} from '../ui-shared/ui-shared.module'

import {ProjectRoutingModule} from './project-routing.module'
import {ProjectComponent} from './project.component'
import {CreativePreviewComponent} from '../creative/creative-preview/creative-preview.component'

import {NgxMasonryModule} from 'ngx-masonry'
import {ProjectEditComponent} from './project-edit/project-edit.component';
import { ProjectUploadComponent } from './project-upload/project-upload.component';
import { ProjectPreviewComponent } from './project-preview/project-preview.component'

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    PipeModule,
    BrowserAnimationsModule,
    NgxMasonryModule,
    ProjectRoutingModule,
    UISharedModule,
  ],
  declarations: [
    ProjectComponent,
    CreativePreviewComponent,
    ProjectEditComponent,
    ProjectUploadComponent,
    ProjectPreviewComponent,
  ],
  exports: [ProjectComponent, ProjectUploadComponent, ProjectPreviewComponent],
})
export class ProjectModule {}



// WEBPACK FOOTER //
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/project/project.module.ts